
import { MutationTree } from 'vuex';

import { State } from './state';
import { LoaderMutationTypes } from './mutation-types';
import { useStore } from '../index'
import { LoaderActionTypes } from './action-types';



export type Mutations<S = State> = {
    [LoaderMutationTypes.SHOW](state: S): void;
    [LoaderMutationTypes.HIDE](state: S): void;
    [LoaderMutationTypes.PENDING](state: S): void;
    [LoaderMutationTypes.DONE](state: S): void;

}


export const mutations: MutationTree<State> & Mutations = {
    [LoaderMutationTypes.SHOW](state: State) {
        state.loading = true;
    },
    [LoaderMutationTypes.HIDE](state: State) {
        state.loading = false;
    },
    [LoaderMutationTypes.PENDING](state: State) {
        if (state.requestsPending === 0) {
            useStore().dispatch(LoaderActionTypes.ACTION_SHOW);
        }

        state.requestsPending++;
    },
    [LoaderMutationTypes.DONE](state: State) {
        if (state.requestsPending >= 1) {
            state.requestsPending--;
        }

        if (state.requestsPending <= 0) {
            useStore().dispatch(LoaderActionTypes.ACTION_SHOW);
        }
    }
};
